import axiosInstance from "../../Interceptors/axiosInstance.jsx";

const getResult = (response) => {
  const payload = response.data;

  if (!payload?.isSuccess) {
    throw new Error(payload?.message || "Unable to complete the contact request.");
  }

  return payload.result;
};

const toFilterDate = (value) => {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return null;

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const getAllContactForms = async ({
  pageNo = 1,
  pageSize = 10,
  fromDate = null,
  toDate = null,
  search = "",
} = {}) => {
  const response = await axiosInstance.post("contact-page/contact-form/all", {
    pageNo,
    pageSize,
    fromDate: toFilterDate(fromDate),
    toDate: toFilterDate(toDate),
    search: search?.trim() || "",
  });

  return getResult(response);
};

export const getContactFormById = async (id) => {
  const response = await axiosInstance.get(`contact-page/contact-form/${id}`);
  return getResult(response);
};

export const deleteContactForm = async (id) => {
  const response = await axiosInstance.delete(`contact-page/contact-form/${id}`);
  return getResult(response);
};

export const getTop10ContactUs = async () => {
  return getAllContactForms({ pageNo: 1, pageSize: 10 });
};
